import debug from 'debug';

const COLOURS = {
  trace: 'lightblue',
  info: 'slateblue',
  warn: 'pink',
  error: 'red',
};

class Log {
  generateMessage(level, message, source) {
    /**
     * For debugging to work, we need to set a field in the browser’s
     * Local Storage with key debug and the value can be anything,
     * like the name of the app, followed by an asterisk (*).
     *
     * https://github.com/visionmedia/debug
     */
    const createDebug = debug(`blockchain-dapp:${level}`);

    createDebug.color = COLOURS[level];

    if (source) {
      createDebug(source, message);
    } else {
      createDebug(message);
    }

    // Remote logging useful from mobile wallet apps - https://console.re
    // 1. Add index.html after <head>: <script src="//console.re/connector.js" data-channel="a5e5-e106-b891" id="consolerescript"></script>
    // 2. View console logs at: https://console.re/a5e5-e106-b891
    if (console.re) {
      switch (level) {
        case 'trace':
          console.re.trace(message);
          break;
        case 'info':
          console.re.info(message);
          break;
        case 'warn':
          console.re.warn(message);
          break;
        case 'error':
          console.re.error(message);
          break;
        default:
        console.re.log(message);
      }
    }
  }

  trace(message, source) {
    return this.generateMessage('trace', message, source);
  }

  info(message, source) {
    return this.generateMessage('info', message, source);
  }

  warn(message, source) {
    return this.generateMessage('warn', message, source);
  }

  error(message, source) {
    return this.generateMessage('error', message, source);
  }
}

export default new Log();



// WEBPACK FOOTER //
// ./src/utils/Log.js